export const getAvatarText = (first , last ) => {
    let char = first ? first.charAt(0) : null;
    if( last ) {
        char = char + last.charAt(0)
    }
    return char;
}